import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'
import { jwtDecode } from 'jwt-decode'

export const admin_login = createAsyncThunk(
  'auth/admin_login',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    // console.log(info);
    try {
      const { data } = await api.post('/admin-login', info, {
        withCredentials: true,
      })
      localStorage.setItem('accessToken', data.token)

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const admin_register = createAsyncThunk(
  'auth/admin_register',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/admin-register', info, {
        withCredentials: true,
      })
      // localStorage.setItem('accessToken', data.token);
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_admin_users = createAsyncThunk(
  'auth/get_admin_users',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-admin-users?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const delete_admin_user = createAsyncThunk(
  'auth/delete_admin_user',
  async ({ userId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-admin-user/${userId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const delete_customer_user = createAsyncThunk(
  'auth/delete_customer_user',
  async ({ userId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-customer-user/${userId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const admin_update = createAsyncThunk(
  'seller/admin_update',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/admin-update', info, {
        withCredentials: true,
      })
      // localStorage.setItem('accessToken', data.token);

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// end method

export const admin_update_password = createAsyncThunk(
  'admin/admin_update_password',
  async ({ userId, password }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        '/admin-update-password',
        { userId, password },
        {
          withCredentials: true,
        }
      )
      // localStorage.setItem('accessToken', data.token);

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// end method

export const admin_image_upload = createAsyncThunk(
  'auth/admin_image_upload',
  async ({ userId, image }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const formData = new FormData()
      formData.append('image', image)
      formData.append('userId', userId)

      const { data } = await api.post(
        `/admin-image-upload/${userId}`,
        formData,
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// end method

// export const seller_login = createAsyncThunk(
//   'auth/seller_login',
//   async (info, { rejectWithValue, fulfillWithValue }) => {
//     // console.log(info);
//     try {
//       const { data } = await api.post('/seller-login', info, {
//         withCredentials: true,
//       })
//       // console.log(data);
//       localStorage.setItem('accessToken', data.token)
//       return fulfillWithValue(data)
//     } catch (error) {
//       // console.log(error.response.data)
//       return rejectWithValue(error.response.data)
//     }
//   }
// )

export const get_user_info = createAsyncThunk(
  'auth/get_user_info',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-user', { withCredentials: true })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_customers = createAsyncThunk(
  'auth/get_customers',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-customers?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_request_customers = createAsyncThunk(
  'auth/get_request_customers',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-request-customers?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const customer_status_update = createAsyncThunk(
  'auth/customer_status_update',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(`/customer-status-update`, info, {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

// export const get_order_notifications = createAsyncThunk(
//   'orders/get_order_notifications',
//   async (role, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.post(
//         '/get-order-notifications',
//         { role },
//         {
//           withCredentials: true,
//         }
//       )

//       return fulfillWithValue(data)
//     } catch (error) {
//       return rejectWithValue(error.response.data)
//     }
//   }
// )
// End Method

export const customer_request_printHouse = createAsyncThunk(
  'auth/customer_request_printHouse',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/customer/request', info)

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_customer = createAsyncThunk(
  'auth/get_customer',
  async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/get-customer/${userId}`, {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// end method

// export const get_seller = createAsyncThunk(
//   'seller/get_seller',
//   async (sellerId, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.get(`/get-seller/${sellerId}`, {
//         withCredentials: true,
//       })
//       //  console.log(data)
//       return fulfillWithValue(data)
//     } catch (error) {
//       // console.log(error.response.data)
//       return rejectWithValue(error.response.data)
//     }
//   }
// )

export const add_coupon = createAsyncThunk(
  'auth/add_coupon',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/add-coupon', info, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_coupons = createAsyncThunk(
  'seller/get_coupons',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-coupons', {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const update_coupon = createAsyncThunk(
  'category/update_coupon',
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/update-coupon', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const delete_coupon = createAsyncThunk(
  'coupon/delete_coupon',
  async ({ couponId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-coupon/${couponId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const delete_orders = createAsyncThunk(
  'order/delete_orders',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete('/delete-orders', {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const delete_all_coupons = createAsyncThunk(
  'coupon/delete_all_coupons',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete('/delete-all-coupons', {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const profile_info_add = createAsyncThunk(
  'auth/profile_info_add',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/profile-info-add', info, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// end method

export const add_notification = createAsyncThunk(
  'auth/add_notification',
  async (
    {
      authId,
      orderId,
      delivery_status,
      order_status,
      enNote,
      kuNote,
      arNote,
      createdAt,
    },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post(
        '/add-notification',
        {
          authId,
          orderId,
          delivery_status,
          order_status,
          enNote,
          kuNote,
          arNote,
          createdAt,
        },
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const add_notification_poster = createAsyncThunk(
  'auth/add_notification_poster',
  async (
    { authId, orderId, delivery_status, enNote, kuNote, arNote, createdAt },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post(
        '/add-notification-poster',
        { authId, orderId, delivery_status, enNote, kuNote, arNote, createdAt },
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const add_notification_stock = createAsyncThunk(
  'auth/add_notification_stock',
  async (
    { authId, orderId, delivery_status, enNote, kuNote, arNote, createdAt },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.post(
        '/add-notification-stock',
        { authId, orderId, delivery_status, enNote, kuNote, arNote, createdAt },
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_notifications = createAsyncThunk(
  'auth/get_notifications',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-notifications', {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const update_auth_notification = createAsyncThunk(
  'notification/update_auth_notification',
  async ({ notificationId, authId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        '/order-notifications/update',
        { notificationId, authId },
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const delete_all_notification = createAsyncThunk(
  'notification/delete_all_notification',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete('/delete-all-notification', {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const delete_notification = createAsyncThunk(
  'coupon/delete_notification',
  async ({ notificationId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        `/delete-notification/${notificationId}`,
        {
          withCredentials: true,
        }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

const returnRole = (token) => {
  if (token) {
    const decodeToken = jwtDecode(token)
    const expireTime = new Date(decodeToken.exp * 1000)
    if (new Date() > expireTime) {
      localStorage.removeItem('accessToken')
      return ''
    } else {
      return decodeToken.role
    }
  } else {
    return ''
  }
}

// end Method

export const logout = createAsyncThunk(
  'auth/logout',
  async ({ navigate, role }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/logout', { withCredentials: true })
      localStorage.removeItem('accessToken')
      if (
        role === 'admin' ||
        role === 'poster' ||
        role === 'stockAdmin' ||
        role === 'orderAdmin'
      ) {
        navigate('/admin/login')
      } else {
        navigate('/login')
      }
      // if (role === 'admin' || role === 'poster' || role === 'stockAdmin') {
      //   navigate('/admin/login')
      // }
      // {
      //   navigate('/admin/login')
      // }
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// end Method

export const authReducer = createSlice({
  name: 'auth',
  initialState: {
    successMessage: '',
    errorMessage: '',
    loader: false,
    adminUsers: [],
    customers: [],
    customersRequest: [],
    totalCustomers: 0,
    totalOrders: 0,
    couponCodes: [],
    authNotification: {},
    authNotifications: [],
    orderNotifications: [],
    totalOrderNotification: 0,
    notification: '',
    couponCode: '',
    totalAdmin: 0,
    orders: [],
    adminUser: '',
    customerProfile: '',
    userInfo: '',
    role: returnRole(localStorage.getItem('accessToken')),
    token: localStorage.getItem('accessToken'),
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(admin_login.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(admin_login.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(admin_login.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.token = payload.token

        state.role = returnRole(payload.token)
      })

      .addCase(logout.fulfilled, (state, { payload }) => {
        state.loader = false
        state.userInfo = ''
      })

      .addCase(admin_register.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(admin_register.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(admin_register.fulfilled, (state, { payload }) => {
        state.loader = false
        state.adminUser = payload.adminUser
        state.successMessage = payload.message
      })

      .addCase(get_customer.fulfilled, (state, { payload }) => {
        state.customerProfile = payload.customerProfile
      })

      .addCase(get_user_info.fulfilled, (state, { payload }) => {
        state.loader = false
        state.userInfo = payload.userInfo
      })

      .addCase(get_admin_users.fulfilled, (state, { payload }) => {
        state.loader = false
        state.adminUsers = payload.adminUsers
        state.totalAdmin = payload.totalAdmin
      })
      .addCase(get_admin_users.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })

      .addCase(get_customers.fulfilled, (state, { payload }) => {
        state.loader = false
        state.customers = payload.customers
        state.totalCustomers = payload.totalCustomers
      })
      .addCase(get_customers.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })

      .addCase(customer_request_printHouse.pending, (state) => {
        state.loader = true
        state.errorMessage = null
        state.successMessage = null
      })
      .addCase(customer_request_printHouse.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error || 'Something went wrong'
        state.loader = false
      })
      .addCase(customer_request_printHouse.fulfilled, (state, { payload }) => {
        // const userInfo = decodeToken(payload.token)
        state.successMessage = 'Request sent successfully'
        state.loader = false

        // state.userInfo = payload.customer
      })

      .addCase(customer_status_update.fulfilled, (state, { payload }) => {
        state.customerProfile = payload.customer
        state.successMessage = payload.message
      })

      .addCase(get_request_customers.fulfilled, (state, { payload }) => {
        state.loader = false
        state.customersRequest = payload.customersRequest
        state.totalCustomers = payload.totalCustomers
      })
      .addCase(get_request_customers.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })

      .addCase(delete_admin_user.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.adminUsers = payload.adminUsers
      })

      .addCase(delete_customer_user.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.customers = payload.customers
      })

      .addCase(admin_update.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(admin_update.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(admin_update.fulfilled, (state, { payload }) => {
        state.loader = false
        state.adminUser = payload.adminUser
        state.successMessage = payload.message
      })

      .addCase(admin_image_upload.pending, (state, { payload }) => {
        state.loader = true
      })

      .addCase(admin_image_upload.fulfilled, (state, { payload }) => {
        state.loader = false
        state.adminUser = payload.adminUser
        state.successMessage = payload.message
      })

      .addCase(admin_update_password.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(admin_update_password.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(admin_update_password.fulfilled, (state, { payload }) => {
        state.loader = false
        state.adminUser = payload.adminUser
        state.successMessage = payload.message
      })

      .addCase(profile_info_add.pending, (state, { payload }) => {
        state.loader = true
      })

      .addCase(add_coupon.fulfilled, (state, { payload }) => {
        state.loader = false
        state.couponCodes = payload.couponCodes
        state.successMessage = payload.message
      })
      .addCase(get_coupons.fulfilled, (state, { payload }) => {
        state.couponCodes = payload.couponCodes
      })
      .addCase(update_coupon.fulfilled, (state, { payload }) => {
        state.loader = false
        state.couponCodes = payload.couponCodes
        state.successMessage = payload.message
      })

      .addCase(delete_coupon.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.couponCodes = payload.couponCodes
      })

      .addCase(delete_all_coupons.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.couponCodes = []
      })

      .addCase(delete_orders.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.orders = []
      })

      .addCase(profile_info_add.fulfilled, (state, { payload }) => {
        state.loader = false
        state.userInfo = payload.userInfo
        state.successMessage = payload.message
      })

      .addCase(add_notification.fulfilled, (state, { payload }) => {
        state.loader = false
        // state.authNotification = payload.orderNotification
        // state.successMessage = payload.message
      })

      .addCase(add_notification_poster.fulfilled, (state, { payload }) => {
        state.loader = false
        // state.authNotification = payload.orderNotification
        state.successMessage = payload.message
      })

      .addCase(add_notification_stock.fulfilled, (state, { payload }) => {
        state.loader = false
        // state.authNotification = payload.orderNotification
        state.successMessage = payload.message
      })

      .addCase(get_notifications.fulfilled, (state, { payload }) => {
        // state.authNotifications = payload.notifications
      })

      // .addCase(get_order_notifications.fulfilled, (state, { payload }) => {
      //   state.authNotifications = payload.orderNotifications
      //   state.totalOrderNotification = payload.totalOrderNotification
      // })

      .addCase(update_auth_notification.fulfilled, (state, { payload }) => {
        state.loader = false
        // state.authNotifications = payload.notifications
        state.successMessage = payload.message
      })
      .addCase(delete_notification.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.authNotifications = payload.notifications
      })

      .addCase(delete_all_notification.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.authNotifications = []
        state.totalOrderNotification = 0
      })
  },
})
export const { messageClear } = authReducer.actions
export default authReducer.reducer
